export default __webpack_public_path__ + "static/media/noah.582b7a10.jpg";